import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useRef, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ProvidersSwiper from "../Games/ProvidersSwiper";
import PageBanner from "../PageBanner";
import ProvidersMobileSwiper from "../Games/ProvidersMobileSwiper";
import GridContainer from "../Games/GridContainer";
import { MdOutlineCasino } from "react-icons/md";
import { PiCoinsBold } from "react-icons/pi";
import FilterSearch from "../Virtual/FilterSearch";
import FilterTypes from "../Virtual/FilterTypes";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import SmartSoftGameBox from "../GamerBoxes/SmartSoftGameBox";
import BLAS975GameBox from "../GamerBoxes/BLAS975GameBox";
import { useParams } from "react-router-dom";
import BannerCarousel from "../Home/BannerCarousel";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";
import NoGamesFound from "./NoGamesFound";
import MatGameBox from "../GamerBoxes/MatGameBox";
import InnovaBox from "../GamerBoxes/InnovaBox";
import { SiteFeatures } from "config/siteFeatures";
import BannerCarouselV2 from "../Home/BannerCarouselV2";
import BannerCarouselV3 from "../Home/BannerCarouselV3";

const ScrollableListView = (props) => {
  const {
    user,
    loggedIn,
    sports,
    games,
    UpdateSport,
    data,
    pb,
    provider,
    setProvider,
    title,
    children,
    FilterSearchValue,
    setFilterSearchValue,
    selectedProviders,
    setSelectedProviders,
    permissions,
  } = props;
  const [loading, setLoading] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isNavVisible, setIsNavVisible] = useState(true);

  const [visibleData, setVisibleData] = useState([]);
  const containerRef = useRef(null);

  const [currentProvider, setCurrentProvider] = useState(null);
  const [activeFilterButton, setActiveFilterButton] = useState(0); // 0 = hiçbiri, 1 = buton1, 2 = buton2

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;

      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1);
        containerRef.current.style.height = `${h}px`;
      }
    } catch (error) {}
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
    /*
    const _group = props.data.reduce((a, v) => ((a[v._middleware === "innova" ? `${v.vendor}_innova` : v.vendor] ??= []).push(v), a), {})
    const _ex = Object.keys(_group).map(x => {
      return ({
        "AllowToChilds": true,
        "Type": "bool",
        "SettingName": `${_group[x][0]._midleware.toUpperCase()}_${x.toUpperCase()}_TVGAMES_ACCESS`,
        "DefaultValue": "true",
        "Category": "PROVIDERS",
        "SettingsID": 1,
        "Value": true
      })
    })
    debugger
    */
  }, []);

  // Scroll pozisyonunu geri yükle
  useEffect(() => {
    if (containerRef.current) {
      const scrollKey = `scroll_${window.location.pathname}`;
      const savedScrollTop = localStorage.getItem(scrollKey);

      if (savedScrollTop) {
        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTop = parseInt(savedScrollTop);
          }
        }, 100);
      }
    }
  }, [data]);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    // Scroll pozisyonunu localStorage'a kaydet
    const scrollKey = `scroll_${window.location.pathname}`;
    localStorage.setItem(scrollKey, scrollTop.toString());
    /*
        // Navbar görünürlüğünü kontrol et
        if (scrollTop > lastScrollTop && scrollTop > 100) {
          // Aşağı scroll - navbar'ı gizle
          setIsNavVisible(false);
        } else {
          // Yukarı scroll - navbar'ı göster
          setIsNavVisible(true);
        }
        */
    setLastScrollTop(scrollTop);
  };

  const providerPermissions = {
    goldenrace: "INNOVA_GOLDENRACE_VIRTUAL_ACCESS",
    "pragmatic-casino": "INNOVA_PRAGMATIC-VIRTUAL_VIRTUAL_ACCESS",
    "pragmatic-virtual": "INNOVA_PRAGMATIC-VIRTUAL_VIRTUAL_ACCESS",
    smartsoft: "INNOVA_SMARTSOFT_VIRTUAL_ACCESS",
    livegames: "INNOVA_LIVEGAMES_VIRTUAL_ACCESS",
    ezugi: "INNOVA_EZUGI_VIRTUAL_ACCESS",
    "1x2gaming": "INNOVA_1X2GAMING_VIRTUAL_ACCESS",
    tada: "INNOVA_TADA_VIRTUAL_ACCESS",
    "pascal-virtual": "INNOVA_PASCAL-VIRTUAL_VIRTUAL_ACCESS",
  };

  return (
    <Translation>
      {(t) => (
        <div>
          <div
            style={{
              overflowY: "auto",
              height: "calc(100dvh - 100px)",
              maxHeight: "calc(100dvh - 100px)",
              WebkitOverflowScrolling: "touch",
              paddingBottom: "calc(120px + env(safe-area-inset-bottom))",
            }}
            ref={containerRef}
            onScroll={handleScroll}
            className="pb-[20px] "
            onLoad={adjustHeight}
          >
            <BannerCarouselV3 banners={banners} />

            {/*
              <section className=" py-2 mobile-show ">
              <ProvidersMobileSwiper _data={[...GameProviders]} />
            </section>

            <section className="py-2 mobile-hide">
              <ProvidersSwiper _data={[...GameProviders]} />
            </section>

                 <section className="mb-1">
              <FilterTypes />
            </section>

            */}

            <section className="mb-1">
              <FilterTypes
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                setProvider={setProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={setSelectedProviders}
                games={games}
                onFilterButtonsChange={setActiveFilterButton}
              />
            </section>

            {/* Oyun Listesi veya Boş Durum */}

            <div
              className={`px-1 pt-4 grid ${
                activeFilterButton === 2 ? "grid-cols-3" : "grid-cols-2"
              } sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-2 md:gap-4`}
            >
              {data &&
                [
                  ...(!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn
                    ? data
                    : data.filter(
                        (x) =>
                          permissions?.[providerPermissions[x.vendor]]?.Value,
                      )),
                ]
                  .filter((x) => {
                    let _fieldKey =
                      x._midleware == "innova"
                        ? "title"
                        : x._midleware == "matgame"
                          ? "name"
                          : "gameName";
                    const __XXX = x[_fieldKey]
                      ?.toLocaleLowerCase()
                      .includes(FilterSearchValue?.toLocaleLowerCase());
                    return __XXX;
                  })
                  .map((item, index) => {
                    switch (item._midleware) {
                      case "innova":
                        return (
                          <InnovaBox
                            key={index}
                            isLive={false}
                            index={index}
                            item={item}
                          />
                        );
                      case "matgame":
                        return (
                          <MatGameBox
                            key={index}
                            isLive={false}
                            index={index}
                            item={item}
                          />
                        );
                      default:
                        return <></>;
                    }
                  })}
            </div>
            {(!data || data.length == 0) && (
              <NoGamesFound title={title} showRefreshButton={false} />
            )}

            <Footer />
          </div>

          <BottomNavigation
            //  permissions={props.permissions}
            isNavVisible={isNavVisible}
          />
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    permissions,
    permissionsAll,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateSport: (data) => dispatch(gameAction.UpdateSportsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollableListView);

export const GetGamePoster = (cat, data) => {
  switch (cat) {
    case "pragmatic-casino":
      return `https://common-static.ppgames.net/game_pic/square/200/${data.gameID}.png`;
    case "smartsoft":
      return `https://maxbetone.s3.eu-central-1.amazonaws.com/images/smartsoft/${data.GameName}.png`.toLowerCase();
    default:
      break;
  }
};

const banners = [
  {
    id: 1,
    img: require("../../../assets/img/home/slots.png"),
    gradient: "from-blue-600 to-blue-800",
    path: "/casino",
  },
  {
    id: 2,
    img: require("../../../assets/img/home/livecasino.png"),

    gradient: "from-secondary-600 to-secondary-800",
    path: "/live-casino",
  },
  {
    id: 3,
    img: require("../../../assets/img/home/womensports.png"),

    gradient: "from-green-600 to-green-800",
    path: "/",
  },
  {
    id: 4,
    img: require("../../../assets/img/home/jackpot1.png"),

    gradient: "from-purple-600 to-purple-800",
    path: "/my-account/",
  },
];
